import { render } from "./SpotifyPlayer.vue?vue&type=template&id=f1488f5e&scoped=true"
import script from "./SpotifyPlayer.vue?vue&type=script&lang=js"
export * from "./SpotifyPlayer.vue?vue&type=script&lang=js"

import "./SpotifyPlayer.vue?vue&type=style&index=0&id=f1488f5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1488f5e"]])

export default __exports__